export default __webpack_public_path__ + "static/media/logo.65597ff0.png";